// extracted by mini-css-extract-plugin
export default {"JobworkPartiesPage":"JobworkPartiesPage_JobworkPartiesPage__o1B23"};